import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RequestStoreService {

  private storedRequests: StoredRequest[] = [];

  getRequestByKey(key: string): StoredRequest {
    return this.storedRequests.filter(x => x.key === key)[0];
  }

  storeRequest(newRequest: StoredRequest): void {
    const previous = this.storedRequests.filter(x => x.key === newRequest.key)[0];
    if (previous) {
      previous.request = newRequest.request;
    } else {
      this.storedRequests.push(newRequest);
    }
  }
}

export class StoredRequest {
  key: string;
  request: Observable<any>;
}
